// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/circuit-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/circuit-procedures/circuit-procedures.js';

mount([g0]);
